import { useFormContext } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';

import AddressGroupV2 from 'components/field/AddressGroupV2';
import FormItem from 'components/form/FormItem';

import OTPVerification from 'pages/OTP/OTPVerification';

import { setUserDetails } from 'stores/userSlice';

import BaseForm from './BaseForm';
import * as S from './Tabs.styled';

const defaultColSpan = {
	md: 6
};

const fullColSpan = {
	md: 12
};

const VerificationAndAddress = ({ isLoading }) => {
	const { watch, clearErrors, reset } = useFormContext();
	const dispatch = useDispatch();
	const user = useSelector((state) => state?.user);

	return (
		<S.SectionContainer>
			<BaseForm title="verifyPhoneNumber">
				<FormItem colSpan={defaultColSpan} label="mobileNumber" isLoading={isLoading}>
					<OTPVerification
						name="phone"
						type="phone"
						otpType="currentPhone"
						isVerified={user.mobileVerified}
						onVerification={(value) => {
							clearErrors('phone');
							reset({ ...watch(), phone: value, isMobileVerified: true });
							dispatch(
								setUserDetails({
									phone: value,
									mobileVerified: true,
									...(user.userType === 'companyAdmin' && { companyAdminVerified: true })
								})
							);
						}}
					/>
				</FormItem>
			</BaseForm>
			<S.Line />
			<BaseForm title="tellUsYourAddress">
				<AddressGroupV2
					formFieldName="address"
					formMode="edit"
					isLoading={isLoading}
					disabled={watch('hasWarehouse')}
					restrictions={{
						country: {
							isNotDifferent: false,
							code: watch('address.countryName')
						}
					}}
					fieldsColspan={{
						address: {
							sm: 12
						},
						country: fullColSpan,
						state: fullColSpan,
						city: fullColSpan,
						district: fullColSpan,
						zipCode: fullColSpan,
						lat: {
							md: 3
						},
						lng: {
							md: 3
						}
					}}
				/>
			</BaseForm>
		</S.SectionContainer>
	);
};

export default VerificationAndAddress;
